import { Inject, Injectable } from '@angular/core';
import { StorageServiceInterface, UserApiService, UserDto, UserServiceInterface } from 'common';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class UserService implements UserServiceInterface {
  private static userStorageKey = 'user';

  constructor(private userApiService: UserApiService,
              @Inject('StorageService') private storageService: StorageServiceInterface,
  ) {
  }

  // Override
  refreshUser(data?: { forceReload?: boolean }): Observable<any> {
    return this.findMyself()
      .pipe(
        mergeMap((user) => {
          if (!user || data?.forceReload) {
            return this.userApiService.getMyself()
              .pipe(
                mergeMap((myself: UserDto) => this.saveMyself(myself)),
                catchError(err => {
                  if (err.error?.ref == 'USER_NOT_FOUND') {
                    throw new Error("USER_NOT_FOUND");
                  }
                  throw err;
                })
              );
          }
          return of(void 0);
        })
      );
  }

  // Override
  saveMyself(user: UserDto): Observable<void> {
    this.saveUser(user);
    return of(void 0);
  }

  // Override
  saveUser(user: UserDto): Observable<void> {
    return this.storageService.storeItem(UserService.userStorageKey, JSON.stringify(user));
  }

  // Override
  hasMyself(): Observable<boolean> {
    return this.storageService.hasItem(UserService.userStorageKey);
  }

  // Override
  getMyself(): Observable<UserDto> {
    return this.findMyself()
      .pipe(
        tap(user => {
          if (!user) {throw new Error('user not found');}
        })
      );
  }

  // Override
  getMyselfUserName(): Observable<string> {
    return this.getMyself()
      .pipe(
        map((user: UserDto) => user.firstName + ' ' + user.lastName)
      );
  }

  // Override
  clearMyself(): Observable<void> {
    this.storageService.cleanAll();
    return of(void 0);
  }

  private findMyself(): Observable<UserDto | undefined> {
    return this.storageService.getItem(UserService.userStorageKey)
      .pipe(
        map(user => user ? JSON.parse(user) as UserDto : undefined)
      );
  }
}
